import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';
import LinkIcon from '@material-ui/icons/Link';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PaletteIcon from '@material-ui/icons/Palette';
import FormatSizeIcon from '@material-ui/icons/FormatSize';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const LinkManagement = ({ language, classes, refs }) => {
    let explanations = [
        {
            id: 'tutorial.links.explanation1',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.links.toolIcon'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <LinkIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/LinkTool.jpg`,
            ],
        },
        {
            id: 'tutorial.links.creating',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.links.creating.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/LinkCreate.jpg`,
            ],
        },
        {
            id: 'tutorial.links.editing',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.links.editing.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                            <MoreVertIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/LinkEdit.jpg`,
            ],
        },
        {
            id: 'tutorial.links.preview',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.links.preview.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                            <CheckBoxIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
        },
        {
            id: 'tutorial.links.styling',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.links.styling.color'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <PaletteIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.links.styling.size'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <FormatSizeIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/LinkStyle.jpg`,
            ],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLesson-links'}
            title={'tutorial.manageLesson.links.title'}
            explanations={explanations}
            imageTop={false}
        />
    );
};

export default LinkManagement;
